import { DirectiveOptions } from "vue";

const isSpanishKey = (event: KeyboardEvent): void => {
  // NOTE: It doesn't prevent special chars from COPY-PASTE

  // Unicode
  // \u00C0-\u00FF Latin-1 Supplement (https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block))
  // \u0100-\u017F Latin Extended-A (https://en.wikipedia.org/wiki/Latin_Extended-A)
  // \u0180-\u024F Latin Extended-B (https://en.wikipedia.org/wiki/Latin_Extended-B)
  // \u1E00-\u1EFF Latin Extended Additional (https://en.wikipedia.org/wiki/Latin_Extended_Additional)

  // https://www.utf8-chartable.de/
  // https://www.utf8-chartable.de/unicode-utf8-table.pl?start=256

  if (
    !/^[A-Za-z\u0020\u00C0-\u00D6\u00D9-\u00DC\u00E0-\u00F6\u00F8-\u00FF]+$/.test(event.key) &&
    event.key != "Backspace" &&
    event.key != "Delete" &&
    event.key != "ArrowLeft" &&
    event.key != "ArrowRight"
  ) {
    event.preventDefault();
  }
};

const directive: DirectiveOptions = {
  bind(el) {
    el.addEventListener("keydown", isSpanishKey);
  },
  unbind(el) {
    el.removeEventListener("keydown", isSpanishKey);
  }
};

export default directive;
